/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId
   * @param {string} productHandle
   */
  static addProduct(productId, productHandle) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (product) => product.id !== productId
    );

    viewedProducts.unshift({
      id: productId,
      handle: productHandle,
    });

    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * @returns {{id: string, handle: string}[]}
   */
  static getProducts() {
    const stored = JSON.parse(
      localStorage.getItem(this.#STORAGE_KEY) || '[]'
    );

    if (stored.length && typeof stored[0] === 'string') {
      return [];
    }

    return stored;
  }
}